import type { VoidFunctionComponent } from 'react';

import Button from '../../../generic/Button/Button';
import { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic/Button/button-constants';

import styles from './FossabotProjectScopePrompt.module.less';

type Props = {
  onViewProjects: () => void;
};

/**
 * Shown in place of the fossabot connection banner when the issue is viewed
 * outside project scope (global or release group): a fossabot PR targets
 * exactly one repository, so the user must open the issue in a project to
 * create one.
 */
export const FossabotProjectScopePrompt: VoidFunctionComponent<Props> = ({ onViewProjects }) => (
  <div className={styles.prompt} data-testid="fossabot-project-scope-prompt">
    <span className={styles.iconWrapper} aria-hidden>
      <img src="/img/fossabot-logo-color.svg" alt="" />
    </span>
    <span className={styles.text}>
      <span className={styles.heading}>
        Remediate this issue automatically with <strong>fossabot</strong>.
      </span>
      <span className={styles.body}>
        If you review this issue{' '}
        <Button type={BUTTON_TYPE.ANCHOR} size={BUTTON_SIZE.SMALL} onClick={onViewProjects}>
          at the project level
        </Button>
        , you&apos;ll be able to use{' '}
        <strong>fossabot</strong> to automatically create a remediation PR.
      </span>
    </span>
  </div>
);
